export const PARAM_KEY_EQUIPMENT = "equipment"
export const EQUIPMENT_CODE_URL_PARAM = "equipmentType"
export const EQUIPMENT_CONDITION_URL_PARAM = "equipmentCondition"
export const EQUIPMENT_TAGS_URL_PARAM = "equipmentTags"
export const EQUIPMENT_ANTI_TAGS_URL_PARAM = "equipmentAntiTags"